"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _L634CRNJcjs = require('../__chunks/L634CRNJ.cjs');
require('../__chunks/JLMLKTUB.cjs');


exports.HeadingLevel = _L634CRNJcjs.HeadingLevel;
